<template>

    <section class="user_section">
        <!-- <UserLnb :navTitle="navTitle" :bgStyle="'type2'" /> -->
        <!-- <div class="title jc">
            <h2>코끼리 탕전실 인사말</h2>
        </div> -->
                                
        <article class="view intro w1200">
            <!-- 원장님 인사말  -->
            <div>
                <div class="txt_box">
                    <div style="intro">
                        <img 
                            src="@/assets/img/layout/introduce_elephant.webp"
                            alt=""
                            class="w100"
                        >
                    </div>
                    <!-- <div class="img_wrap"><img src="@/assets/img/layout/intro_logo.png" alt=""></div>
                    <div class="desc">
                    <div class="title"><h2>안녕하세요. <br> <strong>코끼리원외탕전</strong>을 방문해주셔서 감사합니다.</h2></div>
                         <p>
                                저희 <strong>코끼리 원외탕전실</strong>은 보건복지부의 원외탕전 인증 기준의 방충, 방서, 온도, 습도 조절이 되는 위생적인 시설을 갖추고 
                                미국국제위생협회 최우수등급의 정수시설을 거친 깨끗한 정제수로, 식약처 GMP인증된 한약재로 원장님들의 주문해주신 처방전대로 한약사님들이 정확하고 
                                정직하게 조제 및 탕전하여 최상의 약효를 내도록 최선을 다하고 있습니다. 더불어 양질의 합리적인 가격의 한약재를 구비하고, 깨끗하고 정직하게 탕전하여 
                                한의원 경영에 도움이 되도록 노력하고 있습니다.
                                <br>
                                <br>
                                그리고 조제부터 탕전, 포장 및 발송까지 모든 공정에서 
                                보건복지부 원외탕전 인증 기준의 철저한 위생 관리, 생산 설비 관리, 품질 관리 시스템을 통해 안전하고 믿을 수 있는 한약을 
                                생산 공급하여 한의원과 한의학 이미지 향상을 위해서 항상 최선을 다하겠습니다. 
                        </p>
                        <div class="sign">
                            <img src="@/assets/img/layout/user_logo.svg" alt="">
                            <span class="ar">직원 일동 </span>
                        </div>
                    </div> -->
                </div>
            </div>  
        </article>
                    
    </section>

</template>
<script>

    export default {
        name: 'Introduce',
        components: {
        },
        watch: {

        },
        mounted() {

        },
        methods: {

        },
        data () {
            return {
                navTitle: ['탕전실 소개', ' 원장님 인사말'],
            }
        }
    }
</script>